import { EmployeeBase } from "../json-schemas/base/employee"
import { ScheduleBase } from "../json-schemas/base/schedule"
import { httpGetRoute, httpPost, httpRecoverable } from "../utils/http.service"
import { I18nService } from "../utils/i18n.service"
import { toUpperCaseFirst } from "../utils/lodash.service"
import i18nScopedData from './schedules.service.yml'

export type ScheduleType = ScheduleBase['schedule_type']
export type ScheduleFrequency = ScheduleBase['frequency']
const i18nScoped = new I18nService(i18nScopedData)

export function scheduleCreate (body: any) {
  return httpRecoverable('POST', `/${httpGetRoute()}/schedules`, { schedule: body }, 'schedule')
}

export function scheduleCancelBroadcast (id: number) {
  return httpPost(`/${httpGetRoute()}/schedules/${id}/cancel_broadcast`, {})
}

export function scheduleAssignBroadcastedSchedule (id: number, employeeId: EmployeeBase['id']) {
  return httpPost(`/${httpGetRoute()}/schedules/${id}/assign_broadcasted_schedule`, { employee_id: employeeId })
}

export function scheduleI18nScheduleType (scheduleType: ScheduleType): string {
  return i18nScoped.t(`schedule_type.${scheduleType}`)
}

export function scheduleI18nFrequency (frequency: ScheduleFrequency): string {
  return i18nScoped.t(`frequency.${frequency}`)
}

export function scheduleI18nIntervalFrequency (interval: number, frequency: ScheduleFrequency, { capitalize = true }: { capitalize?: boolean } = {}): string {
  const translation = i18nScoped.t(`interval_frequency.${frequency}`, { count: interval })
  return capitalize ? toUpperCaseFirst(translation) : translation
}

export function scheduleFrequencyToMomentFrequency (frequency: ScheduleFrequency) {
  if (frequency === 'daily') return 'days' as const
  if (frequency === 'weekly') return 'weeks' as const
  if (frequency === 'monthly') return 'months' as const
  throw new Error(`Frequency ${frequency} is not yet supported`)
}

export function scheduleTypesPerAssignableType (assignableType: 'Employee' | 'OfferedServiceResource' | null): ScheduleType[] {
  switch (assignableType) {
    case 'Employee': return ['service_delivery', 'external_delivery', 'meeting_with_operator', 'meeting', 'holiday', 'sick_leave', 'rest', 'unjustified_absence', 'other_type']
    case 'OfferedServiceResource': return ['service_delivery', 'external_delivery', 'other_type']
    default: return ['holiday', 'sick_leave', 'other_type']
  }
}

export function scheduleIsScheduleTypeForAnUnavailability (scheduleType: ScheduleType) {
  // Keep Schedule#schedule_type_forceable? in sync with this function
  return ['holiday', 'sick_leave', 'rest', 'unjustified_absence', 'other_type'].includes(scheduleType)
}
